"use strict";
// blank menu

var links = document.links;
for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    if (links[i].hostname !== window.location.hostname) {
        links[i].target = '_blank';
        links[i].rel = 'noreferrer noopener';
    }
}

// PC menu

$('.has-sub-menu > a').click(function(e) {
    e.preventDefault();
    $(this).next().toggleClass('active-show');
})

$('accordion-tab details > summary').click(function(e) {
    $(this).parents('details').toggleClass('active-show');
})

// nav css height

$('.c-header .head-mast.mast-mobile').css({
    'top': '-' + $('.announcement-bar-wrapper').height()
})


// slick slider

if ($('.c-slick').length > 0) {
    $('.c-slick').slick({
        autoplay:true,
        autoplaySpeed:1500,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        centerMode: true,
        focusOnSelect: true,
        arrows: false,
        centerPadding: '63px',
        prevArrow: '<a class="slick-prev" href="#"><span><img src="https://cdn.shopify.com/s/files/1/0706/0776/5825/t/3/assets/arrow_right-white.svg"></span></a>',
        nextArrow: '<a class="slick-next" href="#"><span><img src="https://cdn.shopify.com/s/files/1/0706/0776/5825/t/3/assets/arrow_right-white.svg"></span></a>',
        responsive: [{
            breakpoint: 767,
            settings: {
                variableWidth: true,
                slidesToShow: 1,
                arrows: true
            }
        }]
    });
}

// remove dot slider when item.length = slider show
if ($('.c-slick__item').length < 4 && window.innerWidth > 767) {
    $('.slick-dots').css({
        opacity: 0
    })
}


$('.head-slot-nav-mobile-link-wrapper .mobile-menu').css({
    'top': $('.head-mast.mast-mobile').height() - 60,
    'padding-bottom': $('.head-mast.mast-mobile').height()
})

// faq
if ($('.section-faq, .scaffold-manufacture').length) {
    $('body .faq__body h2, .scaffold-manufacture__content h2').each(function() {
        let faqTitle = $(this).text();
        let faqId = $(this).attr('id');

        $('#faqItems').append(`<li class="section-faq__list-item"><a href="#${faqId}">${faqTitle}</a></li>`);
    })
}

function updateVariantTableSubtotal() {
    const subtotalEl = document.getElementById('subtotal');
    if (!subtotalEl) return;

    let total = 0;
    document.querySelectorAll('.custom-product-forms .product__table-title').forEach(function(row) {
        const qtyInput = row.querySelector('input.quantity-input-field');
        const price = parseInt(row.getAttribute('data-price') || '0', 10);
        const qty = parseInt(qtyInput?.value || '0', 10);

        if (qty > 0 && price > 0) {
            total += Math.round(price * 1.1) * qty;
        }
    });

    subtotalEl.textContent = '¥' + Math.floor(total / 100).toLocaleString('ja-JP');
}

function initVariantTableSubtotal() {
    updateVariantTableSubtotal();

    document.querySelectorAll('.custom-product-forms input.quantity-input-field').forEach(function(input) {
        input.addEventListener('change', updateVariantTableSubtotal);
        input.addEventListener('input', updateVariantTableSubtotal);
    });

    document.querySelectorAll('.custom-product-forms .quantity-input-button').forEach(function(button) {
        button.addEventListener('click', function() {
            setTimeout(updateVariantTableSubtotal, 0);
        });
    });
}

function getMiniCartSections() {
    const miniCart = document.querySelector('mini-cart');
    if (!miniCart || typeof miniCart.getSectionsToRender !== 'function') {
        return [];
    }

    return miniCart.getSectionsToRender().map(function(section) {
        return section.section;
    });
}

function refreshMiniCart(parsedState) {
    const miniCart = document.querySelector('mini-cart');
    if (!miniCart) return;

    if (parsedState && parsedState.sections && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(parsedState);
    } else if (typeof miniCart.updateSectionContents === 'function') {
        miniCart.updateSectionContents();
    }

    if (typeof miniCart.open === 'function') {
        miniCart.open();
    }

    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'custom-product-form',
            cartData: parsedState
        });
    }

    document.dispatchEvent(new CustomEvent('cart:item-add', {
        detail: {
            items: parsedState.items || [parsedState],
            context: 'MainProductPage'
        }
    }));
}

function setCustomAddToCartLoading(isLoading) {
    document.querySelectorAll('.custom-product-forms .createnewbtn, .productFixed .createnewbtn').forEach(function(button) {
        button.classList.toggle('loading', isLoading);
        button.toggleAttribute('aria-disabled', isLoading);
    });
}

function handleCustomProductFormAddToCart() {
    const items = [];

    document.querySelectorAll('.custom-product-forms .product__table-title').forEach(function(divElement) {
        const inputElement = divElement.querySelector('input.quantity-input-field');
        if (!inputElement) return;

        const dataId = inputElement.getAttribute('data-id');
        const qty = parseInt(inputElement.value, 10);

        if (dataId && qty > 0) {
            items.push({
                id: parseInt(dataId, 10),
                quantity: qty
            });
        }
    });

    if (!items.length) {
        alert('数量入力してください。');
        return;
    }

    const sections = getMiniCartSections();
    const payload = { items: items };

    if (sections.length) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
    }

    setCustomAddToCartLoading(true);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify(payload)
    })
    .then(function(response) {
        return response.json();
    })
    .then(function(parsedState) {
        if (parsedState.status) {
            alert(parsedState.description || 'カートに追加できませんでした。');
            return;
        }

        refreshMiniCart(parsedState);
    })
    .catch(function(error) {
        console.error(error);
        alert('カートに追加できませんでした。');
    })
    .finally(function() {
        setCustomAddToCartLoading(false);
    });
}

// add to cart
let customFormCardBody = $('body').find('.custom-product-forms').length;
if (customFormCardBody) {
    initVariantTableSubtotal();

    $('.custom-product-forms').on('submit', function(evt) {
        evt.preventDefault();
        handleCustomProductFormAddToCart();
    });

    $(document).on('click', '[data-template="product"] .productFixed .createnewbtn', function(evt) {
        evt.preventDefault();
        handleCustomProductFormAddToCart();
    });
}

// add to cart wishlist
let wishlistPage = $('#wishlist').length

if (wishlistPage) {
    let formCard = true;

    function findId() {
        let customFormCardBody = $('body').find('.custom-product-forms').length;
        if (customFormCardBody && formCard == true) {
            $('#wishlist').css({
                'opacity': 1,
                'transition': '1s all'

            });

            let addToCartForm = $('.custom-product-forms');

            if (wishlistPage) {
                $(document).on("click", ".product-info-heading", function() {
                    let handle = $(this).attr('data-handle');
                    let variantId = $(this).attr('data-variant');

                    window.location.href = `/products/${handle}?variant=${variantId}`;
                })
            }

            if (customFormCardBody) {
                const formDefault = document.querySelector('[data-element="add-to-card-form-template"]');
                const buttonAddDefault = formDefault.querySelector('[name="add"]');

                let addToCartForm = $('.custom-product-forms');

                $(addToCartForm).each(function() {
                    $(this).submit(function(evt) {
                        evt.preventDefault();
                        let addNewCartBtn = $(this).find('.createnewbtn')
                        let items = [];
                        let rows = evt.currentTarget.querySelectorAll('.item-submission');

                        for (let i = 0; i < rows.length; i++) {
                            // Get the variant ID and quantity for each row. 
                            let itemData = rows[i];
                            let id = parseInt(itemData.querySelector('input.quantity-input-field').getAttribute('data-id'));
                            let qty = parseInt(itemData.querySelector('input.quantity-input-field').value);


                            if (id && qty > 0) {
                                items.push({
                                    id: id,
                                    quantity: qty
                                });

                            }
                        }
                        if (!items.length) {
                            alert('数量入力してください。');
                            return;
                        }

                        $.post('/cart/add.js', {
                            items: items
                        })

                        .done(function(data) {
                            // console.log( data );
                        })
                        .fail(function() {
                            console.log("error");
                        })
                        .always(function(data) {
                            setTimeout(() => {
                                window.location.href = "/cart/";
                            }, 1000);

                        });
                    })
                })
            }
            formCard = false;
        }
    }

    let runTime = setInterval(findId, 10);
}

// click memu

$('.menu-item__sub-active .parent_filter .group').change(function() {
    if ($(this).prop("checked")) {
        $(this).parents('.menu-item').addClass('active')
    } else {
        $(this).parents('.menu-item').removeClass('active');
        $('.menu-item__sub-item .parent_filter').removeClass('active');
    }
})


// home fillter

let newProductCollection = [];
let usedProductCollection = [];
let specialProductCollection = [];
let urlCollectionNewProduct = '/collections/new';
let urlCollectionUsedProduct = '/collections/used';
let urlCollectionSpecialProduct = '/collections/specialprice';
let inputCategory;

$('.group').change(function() {
    inputCategory = $(this).attr('data-value');
    switch (inputCategory) {
        case 'newProductValue':
            $('a[data-category="newproduct"]').attr('href', '');

            break;
        case 'usedProductValue':
            $('a[data-category="usedproduct"]').attr('href', '');

            break;
        case 'specialProductValue':
            $('a[data-category="special"]').attr('href', '');

            break;
        default:
    }

    let removeItemChild = [];
    let groupValue = $(this).attr('value');
    let ItemChild = $(this).parents('.menu-item__sub-active').find('ul li input');

    $(ItemChild).each(function() {
        removeItemChild.push($(this).attr('value'))
    })

    if ($(this).prop("checked")) {

        switch (inputCategory) {
            case 'newProductValue':
                newProductCollection = newProductCollection.filter(a => !removeItemChild.includes(a)); // remove load item
                newProductCollection.push(groupValue) // push to all

                break;
            case 'usedProductValue':
                usedProductCollection = usedProductCollection.filter(a => !removeItemChild.includes(a)); // remove load item
                usedProductCollection.push(groupValue) // push to all

                break;
            case 'specialProductValue':
                specialProductCollection = specialProductCollection.filter(a => !removeItemChild.includes(a)); // remove load item
                specialProductCollection.push(groupValue) // push to all
                break;
            default:
        }
    } else {
        $(this).parents('.menu-item').find('ul li input').prop('checked', false).removeAttr('checked');

        switch (inputCategory) {
            case 'newProductValue':
                newProductCollection = newProductCollection.filter(a => !removeItemChild.includes(a)); // remove load item
                newProductCollection = newProductCollection.filter(item => item !== groupValue)

                break;
            case 'usedProductValue':
                usedProductCollection = usedProductCollection.filter(a => !removeItemChild.includes(a)); // remove load item
                usedProductCollection = usedProductCollection.filter(item => item !== groupValue)

                break;
            case 'specialProductValue':
                specialProductCollection = specialProductCollection.filter(a => !removeItemChild.includes(a)); // remove load item
                specialProductCollection = specialProductCollection.filter(item => item !== groupValue)

                break;
            default:
        }
    }
})


$('.child').change(function() {
    inputCategory = $(this).attr('data-value');
    switch (inputCategory) {
        case 'newProductValue':
            $('a[data-category="newproduct"]').attr('href', '');

            break;
        case 'usedProductValue':
            $('a[data-category="usedproduct"]').attr('href', '');

            break;
        case 'specialProductValue':
            $('a[data-category="special"]').attr('href', '');

            break;
        default:
    }

    let allItem = $(this).parents('.menu-item__sub-active').find('ul li input');
    let allItemChecked = $(this).parents('.menu-item__sub-active').find('ul li input:checked');
    let groupHeader = $(this).parents('.menu-item__sub-active').find('.group');
    let checkedItem = $(this).attr('value');
    let removeItem = [];

    if ($(this).prop("checked")) {
        switch (inputCategory) {
            case 'newProductValue':
                newProductCollection.push(checkedItem) // add item when checked

                break;
            case 'usedProductValue':
                usedProductCollection.push(checkedItem) // add item when checked

                break;
            case 'specialProductValue':
                specialProductCollection.push(checkedItem) // add item when checked

                break;
            default:
        }

        // add class
        $(this).parents('.parent_filter').addClass('active');

    } else {
        switch (inputCategory) {
            case 'newProductValue':
                $(allItem).each(function() {
                    removeItem.push($(this).attr('value'))
                })

                newProductCollection.pop($(groupHeader).attr('value')) // remove group
                newProductCollection = newProductCollection.filter(a => !removeItem.includes(a)); // remove load item

                $(allItemChecked).each(function() {
                    newProductCollection.push($(this).attr('value'))
                })

                break;
            case 'usedProductValue':
                $(allItem).each(function() {
                    removeItem.push($(this).attr('value'))
                })

                usedProductCollection.pop($(groupHeader).attr('value')) // remove group
                usedProductCollection = usedProductCollection.filter(a => !removeItem.includes(a)); // remove load item

                $(allItemChecked).each(function() {
                    usedProductCollection.push($(this).attr('value'))
                })

                break;
            case 'specialProductValue':
                $(allItem).each(function() {
                    removeItem.push($(this).attr('value'))
                })

                specialProductCollection.pop($(groupHeader).attr('value')) // remove group
                specialProductCollection = specialProductCollection.filter(a => !removeItem.includes(a)); // remove load item

                $(allItemChecked).each(function() {
                    specialProductCollection.push($(this).attr('value'))
                })
                break;
            default:
        }
        // add class
        $(this).parents('.parent_filter').removeClass('active');
    }
})

$('.menu-list__items input').change(function() {
    //　新品商品
    let newProductCollectionJoin = $.map(newProductCollection, function(value) {
        return value
    }).join('&');
    $('a[data-category="newproduct"]').attr('href', `${urlCollectionNewProduct}?${newProductCollectionJoin}`)

    // 中古商品
    let usedProductCollectionJoin = $.map(usedProductCollection, function(value) {
        return value
    }).join('&');

    $('a[data-category="usedproduct"]').attr('href', `${urlCollectionUsedProduct}?${usedProductCollectionJoin}`)

    //special
    let specialProductCollectionJoin = $.map(specialProductCollection, function(value) {
        return value
    }).join('&');
    $('a[data-category="special"]').attr('href', `${urlCollectionSpecialProduct}?${specialProductCollectionJoin}`)
})

// load active sub catelogy
$('.menu-item__sub input[type="checkbox"]').each(function() {
    let countCheckedItem = $(this).filter(':checked').length;
    if(countCheckedItem > 0) {
        $(this).parent('.menu-item__sub-item .checkbox-facet-label').addClass('active')
        $(this).parents('.menu-item__sub-active').find('.checkbox-facet > label > input').prop('checked', true);
    }
})

// reset button
$('.menu-list__btn-reset').click(function(e) {
    e.preventDefault();
    $('.parent_filter').css({
        'color': '#807b77'
    })

    let resetCategory = $(this).attr('data-category');

    switch (resetCategory) {
        case 'resetnewfilter':
            newProductCollection = [];
            $('[data-block="newBlockProduct"] input').prop("checked", false);
            $('a[data-category="newproduct"]').attr('href', urlCollectionNewProduct)

            break;
        case 'resetusedfilter':
            usedProductCollection = [];
            $('[data-block="usedBlockProduct"] input').prop("checked", false);
            $('a[data-category="usedproduct"]').attr('href', urlCollectionUsedProduct)

            break;
        case 'resetspecialfilter':
            specialProductCollection = [];
            $('[data-block="specialBlockProduct"] input').prop("checked", false);
            $('a[data-category="special"]').attr('href', urlCollectionSpecialProduct)

            break;

        default:
    }
})

// set height table
$('.product-list-container .product__table-title').each(function() {
    let caclHeighItemLeft = $(this).find('.item-submission-first-info').height();
    let caclHeightItemRight = $(this).find('.item-submission__right').height();

    let itemGetHeight = $(this).find('.item-submission');

    if (window.innerWidth < 767 && caclHeightItemRight < caclHeighItemLeft) {
        $(itemGetHeight).css({
            'height': caclHeighItemLeft
        })
    }
})


// cart check-privacy

if ($('.main-cart').length) {
    const checkPrivacy = document.getElementById('check-privacy');
    const checkKiyaku = document.getElementById('check-kiyaku');

    checkPrivacy.addEventListener('change', checkBoth);
    checkKiyaku.addEventListener('change', checkBoth);

    function checkBoth() {
        if (checkPrivacy.checked && checkKiyaku.checked) {
            let checkCartError = $('body').find('.cart-error').length;
            if(!checkCartError) {
                $('.cart-footer__checkout-btn button').removeAttr('disabled');
            }
            
        } else {
            $('.cart-footer__checkout-btn button').attr('disabled', 'disabled');
        }
    }

    
}

// purchar info

if ($('.purchase-kv__slider-item').length > 1) {
    $('.purchase-kv__slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: true
    });
}

// modal
if($('.item-step').length > 0) {
    $('.avarta > .avr a').modaal({
        type: 'image',
        is_locked: false,
        closeButton: true,
    });
}


// sort price
// if($('.sort-variant-price').length > 0) {
//     $('.sort-variant-price').each(function() {
//         let $variants = $(this).find('p[data-price]');
//         $variants.sort(function(a, b) {
//             return parseInt($(a).data('price')) - parseInt($(b).data('price'));
//         });

//         $(this).empty().append($variants);

//         $('.sort-variant-price p[data-price="0"]').remove();
//      });
// }


$('.page-number').click(function() {
    if($('[data-template="collection"]').length) {
        let checkPriceVariant = true;

        function findPriceVariant() {
            if (checkPriceVariant == true) {
                // sort price
                $('.sort-variant-price').each(function() {
                    let $variants = $(this).find('p[data-price]');
                    $variants.sort(function(a, b) {
                        return parseInt($(a).data('price')) - parseInt($(b).data('price'));
                    });
                    $(this).empty().append($variants);
                    $('.sort-variant-price p[data-price="0"]').remove();
                });
            }
        }
        let runTime = setInterval(findPriceVariant, 10);
    }
})

// conrol mouse

$('.c-slick__link[href=""]').click(function(e) {
  e.preventDefault();
})